<template>
  <div>
    <!-- <div id="cover"></div> -->
    <div id="map"></div>
  </div>
</template>
 
<script>
import echarts from 'echarts'
// import * as nameMap from './nameMap.js'
export default {
  data () {
    return {
      targetColors: ['black', 'black', 'red', 'purple', 'pink', 'yellow', 'orange', 'skyblue', 'green'],
      mapOptions: {
        title: {
          //text: '世界地图',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        series: [{
          data: [{
            name: '',
            selected: true
          }],
          type: 'map',
          mapType: 'world',
          roam: false,
          label: {
            show: false
          },
          zoom: 1.0,
          itemStyle: {
            // areaColor: '#7B68EE',
            borderWidth: 0.3,
            borderColor: '#000',
            borderType: 'solid'
          },
          tooltip: {
            trigger: 'none'
          },
          emphasis: {
            label: {
              show: false,
              color: 'blue'
            },
            itemStyle: {
              areaColor: 'yellow'
            }
          },
          // nameMap: nameMap.default,
        }]
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.resizeMap);
    this.showMap();

    this.$bus.$on('setMapTarget', this.setTarget);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.resizeMap());

    this.$bus.$off('setMapTarget');
  },
  methods: {
    showMap () {
      let myChart = echarts.init(document.getElementById('map'));
      myChart.setOption(this.mapOptions);
    },
    resizeMap () {
      echarts.init(document.getElementById('map')).dispose();
      this.showMap();
    },
    setTarget ([country, rank]) {
      echarts.init(document.getElementById('map')).dispose();
      let myChart = echarts.init(document.getElementById('map'));
      this.mapOptions.series[0].data[0].name = country;
      this.mapOptions.series[0].emphasis.itemStyle.areaColor = this.targetColors[rank - 1];
      myChart.setOption(this.mapOptions)
    }
  }
}
</script>
<style scoped>
#cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(6, 126, 196);
}
#map {
  width: 100%;
  margin: 0 auto;
  height: 250px;
  border: 1px solid #eeeeee;
  background-size: 100% 100%;
}
</style>